import moduleItIT from "./it-IT.json" with { type: "json" };
import moduleEnUS from "./en-US.json" with { type: "json" };

export const i18n = {
  "it-IT": { about: moduleItIT },
  "en-US": { about: moduleEnUS },
};
